import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

function defineInterceptor(): void {
  const link = localStorage.getItem('@LiveChat:linkEmpresa');
  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return new Promise((resolve) => {
        const originalRequest = error.config;
        if (
          (error.response.status === 401 || error.response.status === 400) &&
          originalRequest.url === '/login' &&
          originalRequest.method === 'put'
        ) {
          localStorage.removeItem('@LiveChat:token');
          window.location.href = `/${link}`;
        } else if (
          error.response.status === 401 &&
          error.config &&
          !originalRequest.retry
        ) {
          originalRequest.retry = true;
          const refreshToken = localStorage.getItem('@LiveChat:refreshToken');
          const seqUsuario = localStorage.getItem('@LiveChat:seqUsuario');
          const seqEmpresa = localStorage.getItem('@LiveChat:seqEmpresa');

          const res = api
            .put('/login', {
              seqEmpresa,
              seqUsuario,
              refreshToken,
            })
            .then((response) => {
              if (response.data.accessToken) {
                localStorage.setItem(
                  '@LiveChat:token',
                  response.data.accessToken
                );
                localStorage.setItem(
                  '@LiveChat:refreshToken',
                  response.data.refreshToken
                );

                originalRequest.headers.Authorization = `Bearer ${response.data.accessToken}`;
                return api(originalRequest);
              }
              localStorage.removeItem('@LiveChat:token');
              window.location.href = `/${link}`;
              return null;
            });
          resolve(res);
        } else {
          resolve(error.response);
        }
      });
    }
  );
}

defineInterceptor();

export default api;
